import { PulseBaseProvider } from '../../base-classes';

const _hurricaneCacheKey = 'hurricane';
const _hurricaneLegendCacheKey = 'hurricaneLegend';
const _hurricaneUri='/api/hurricanes/v1';
const _hurricaneLegendUri='/api/hurricanes/v1';

const pulseApis = [];
export class HurricaneProvider extends PulseBaseProvider {
    constructor(baseUrl, authId, secret, options, logger) {
        super(baseUrl, authId, secret, options, logger);
        pulseApis.push(this.pulseApi);
        this.storage.sync[_hurricaneCacheKey] = this.hurricaneSyncer.bind(this);
        this.storage.sync[_hurricaneLegendCacheKey] = this.hurricaneLegendSyncer.bind(this);
    }

    // This function doesn't use the base sync implementation because it needs to add indices to the hurricane features.
    // If the API adds that in then it can use the base implementation.
    async hurricaneSyncer(params) {
        const { syncParams, resolve, reject, id } = params;
        let queryParams = {
            ...syncParams.stdParameters
            ,...syncParams.unitParameters
            ,locationType: 'latitudelongitude'
            ,location: `${syncParams.latitude},${syncParams.longitude}`
            ,type: 'geojson'
            ,history: true
            ,forecastCone: true
            ,forecastTrack:true
            ,maxResults: 20
            ,cachedOnly: syncParams.isCached
            ,verbose: syncParams.verbose
        };

        try {
            const response = await syncParams.pulseApi.getData(syncParams.path, queryParams, this.options.timeout, 'json', true);
            if (!response || !response.features) {
                const error = 'Invalid response';
                reject(error);
                return error;
            }

            response.responseTime = Date.now();

            //Add indices to the hurricane features
            for (let i = 0; i < response.features.length; i++) {
                response.features[i].properties.index = i;
            }


            this.storage.save({
                key: syncParams.key,
                id,
                data: response
            });
            resolve(response);
            return response;
        } catch (e) {
            reject(e);
            return e;
        }
    }

    async hurricaneLegendSyncer(params) {
        const { syncParams, resolve, reject, id } = params;
        let queryParams = {
            ...syncParams.stdParameters
            ,lid: 'Hurricane'
            ,cachedOnly: syncParams.isCached
            ,verbose: syncParams.verbose
        };
        return await super.syncData(syncParams.key, id, queryParams, syncParams.path, resolve, reject, null, syncParams.pulseApi);
    }

    async getHurricane(latitude, longitude, isCached, stdParameters, unitParameters, path, verbose, refresh=false) {
        const hurricanePath = path || _hurricaneUri;
        const syncParams = {
            latitude
            ,longitude
            ,verbose: !!verbose
            ,isCached
            ,unitParameters
            ,path: hurricanePath
            , cultureInfo: stdParameters?.cultureinfo
        };
        const id = JSON.stringify(syncParams);

        //Add the standard parameters after generating the ID because they shouldn't be part of the cache key
        syncParams.stdParameters = stdParameters;
        if (refresh) {
            super.removeFromStorage(_hurricaneCacheKey, id);
        }
        return await super.loadFromStorage(_hurricaneCacheKey, id, syncParams);
    }

    async getHurricaneLegend(isCached, stdParameters, path) {
        const syncParams = {
            verbose: false
            ,isCached
            ,stdParameters
            ,path
            , cultureInfo: stdParameters?.cultureinfo
        };
        const id = JSON.stringify(syncParams);
        return await super.loadFromStorage(_hurricaneLegendCacheKey, id, syncParams);
    }

    static getHurricaneLegendCategories() {
        return [
            'Tropical Depression',
            'Tropical Storm',
            'Category 1',
            'Category 2',
            'Category 3',
            'Category 4',
            'Category 5'
        ];
    }

    getDummyActiveHurricane() {
        return {}; /*
        "type": "FeatureCollection",
        "features": [
          {
            "type": "Feature",
            "geometry": {
              "type": "Point",
              "coordinates": [
                -107.9,
                14.2
              ]
            },
            "properties": {
              "n": "DummyName",
              "id": "EP-2-2018",
              "tn": "TropicalStorm",
              "t": 10,
              "c": null,
              "w": 46.0311779,
              "g": 57.5389724012,
              "lat": 14.2,
              "lon": -107.9,
              "dir": 270,
              "s": 8,
              "p": 29.53,
              "dt": "2018-06-06 18:00:00Z",
              "dis": 2456.3579828997,
              "dtype": 3,
              "iid": "CurrentPosition-TropicalStorm-"
            }
          },
          {
            "type": "Feature",
            "geometry": {
              "type": "Point",
              "coordinates": [
                -105.6999,
                14.1
              ]
            },
            "properties": {
              "n": "ALETTA",
              "id": "EP-2-2018",
              "tn": "TropicalDepression",
              "t": 7,
              "c": null,
              "w": 34.5233834,
              "g": 46.0311779209,
              "lat": 14.1,
              "lon": -105.6999,
              "dir": 305,
              "s": 9,
              "p": 29.68,
              "dt": "2018-06-06 00:00:00Z",
              "dis": 2372.810937136,
              "dtype": 1,
              "iid": "HistoricalPosition-TropicalDepression-"
            }
          },
          {
            "type": "Feature",
            "geometry": {
              "type": "Point",
              "coordinates": [
                -106.5,
                14.1
              ]
            },
            "properties": {
              "n": "ALETTA",
              "id": "EP-2-2018",
              "tn": "TropicalStorm",
              "t": 10,
              "c": null,
              "w": 46.0311779,
              "g": 57.5389724012,
              "lat": 14.1,
              "lon": -106.5,
              "dir": 270,
              "s": 6,
              "p": 29.53,
              "dt": "2018-06-06 06:00:00Z",
              "dis": 2404.7202856136,
              "dtype": 1,
              "iid": "HistoricalPosition-TropicalStorm-"
            }
          },
          {
            "type": "Feature",
            "geometry": {
              "type": "Point",
              "coordinates": [
                -107.0999,
                14.7
              ]
            },
            "properties": {
              "n": "ALETTA",
              "id": "EP-2-2018",
              "tn": "TropicalStorm",
              "t": 10,
              "c": null,
              "w": 46.0311779,
              "g": 57.5389724012,
              "lat": 14.7,
              "lon": -107.0999,
              "dir": 280,
              "s": 6,
              "p": 29.53,
              "dt": "2018-06-06 12:00:00Z",
              "dis": 2396.1131431847,
              "dtype": 1,
              "iid": "HistoricalPosition-TropicalStorm-"
            }
          },
          {
            "type": "Feature",
            "geometry": {
              "type": "LineString",
              "coordinates": [
                [
                  -105.6999,
                  14.1
                ],
                [
                  -106.5,
                  14.1
                ],
                [
                  -107.0999,
                  14.7
                ],
                [
                  -107.9,
                  14.2
                ]
              ]
            },
            "properties": {
              "dtype": 2,
              "id": "EP-2-2018"
            }
          },
          {
            "type": "Feature",
            "geometry": {
              "type": "Point",
              "coordinates": [
                -109,
                14.4
              ]
            },
            "properties": {
              "n": "ALETTA",
              "id": "EP-2-2018",
              "tn": "TropicalStorm",
              "t": 10,
              "c": null,
              "w": 57.5389724,
              "g": 69.0467668814,
              "lat": 14.4,
              "lon": -109,
              "dir": 0,
              "s": 0,
              "p": 0,
              "dt": "2018-06-07 03:00:00Z",
              "dis": 2491.5876712438,
              "dtype": 4,
              "iid": "ForecastPosition-TropicalStorm-"
            }
          },
          {
            "type": "Feature",
            "geometry": {
              "type": "Point",
              "coordinates": [
                -110,
                14.5
              ]
            },
            "properties": {
              "n": "ALETTA",
              "id": "EP-2-2018",
              "tn": "TropicalStorm",
              "t": 10,
              "c": null,
              "w": 63.2928696,
              "g": 74.8006641215,
              "lat": 14.5,
              "lon": -110,
              "dir": 0,
              "s": 0,
              "p": 0,
              "dt": "2018-06-07 15:00:00Z",
              "dis": 2528.946305558,
              "dtype": 4,
              "iid": "ForecastPosition-TropicalStorm-"
            }
          },
          {
            "type": "Feature",
            "geometry": {
              "type": "Point",
              "coordinates": [
                -111,
                14.7
              ]
            },
            "properties": {
              "n": "ALETTA",
              "id": "EP-2-2018",
              "tn": "Hurricane",
              "t": 1,
              "c": 1,
              "w": 74.8006641,
              "g": 92.0623558419,
              "lat": 14.7,
              "lon": -111,
              "dir": 0,
              "s": 0,
              "p": 0,
              "dt": "2018-06-08 03:00:00Z",
              "dis": 2561.8690061454,
              "dtype": 4,
              "iid": "ForecastPosition-Hurricane-1"
            }
          },
          {
            "type": "Feature",
            "geometry": {
              "type": "Point",
              "coordinates": [
                -112,
                15
              ]
            },
            "properties": {
              "n": "ALETTA",
              "id": "EP-2-2018",
              "tn": "Hurricane",
              "t": 1,
              "c": 1,
              "w": 80.5545613,
              "g": 97.816253082,
              "lat": 15,
              "lon": -112,
              "dir": 0,
              "s": 0,
              "p": 0,
              "dt": "2018-06-08 15:00:00Z",
              "dis": 2590.5225624445,
              "dtype": 4,
              "iid": "ForecastPosition-Hurricane-1"
            }
          },
          {
            "type": "Feature",
            "geometry": {
              "type": "Point",
              "coordinates": [
                -113.5999,
                16
              ]
            },
            "properties": {
              "n": "ALETTA",
              "id": "EP-2-2018",
              "tn": "Hurricane",
              "t": 1,
              "c": 1,
              "w": 92.0623558,
              "g": 115.077944802,
              "lat": 16,
              "lon": -113.5999,
              "dir": 0,
              "s": 0,
              "p": 0,
              "dt": "2018-06-09 15:00:00Z",
              "dis": 2612.3278663976,
              "dtype": 4,
              "iid": "ForecastPosition-Hurricane-1"
            }
          },
          {
            "type": "Feature",
            "geometry": {
              "type": "Point",
              "coordinates": [
                -115.5999,
                17.2999
              ]
            },
            "properties": {
              "n": "ALETTA",
              "id": "EP-2-2018",
              "tn": "Hurricane",
              "t": 1,
              "c": 1,
              "w": 80.5545613,
              "g": 97.816253082,
              "lat": 17.2999,
              "lon": -115.5999,
              "dir": 0,
              "s": 0,
              "p": 0,
              "dt": "2018-06-10 15:00:00Z",
              "dis": 2642.4171407389,
              "dtype": 4,
              "iid": "ForecastPosition-Hurricane-1"
            }
          },
          {
            "type": "Feature",
            "geometry": {
              "type": "Point",
              "coordinates": [
                -117,
                18
              ]
            },
            "properties": {
              "n": "ALETTA",
              "id": "EP-2-2018",
              "tn": "TropicalStorm",
              "t": 10,
              "c": null,
              "w": 51.7850751,
              "g": 63.2928696413,
              "lat": 18,
              "lon": -117,
              "dir": 0,
              "s": 0,
              "p": 0,
              "dt": "2018-06-11 15:00:00Z",
              "dis": 2676.5962271541,
              "dtype": 4,
              "iid": "ForecastPosition-TropicalStorm-"
            }
          },
          {
            "type": "Feature",
            "geometry": {
              "type": "LineString",
              "coordinates": [
                [
                  -107.9,
                  14.2
                ],
                [
                  -109,
                  14.4
                ],
                [
                  -110,
                  14.5
                ],
                [
                  -111,
                  14.7
                ],
                [
                  -112,
                  15
                ],
                [
                  -113.5999,
                  16
                ],
                [
                  -115.5999,
                  17.2999
                ],
                [
                  -117,
                  18
                ]
              ]
            },
            "properties": {
              "dtype": 5,
              "id": "EP-2-2018"
            }
          },
          {
            "type": "Feature",
            "geometry": {
              "type": "Polygon",
              "coordinates": [
                [
                  [
                    -107.87170639838,
                    14.35561480892
                  ],
                  [
                    -107.84511401378,
                    14.348337537946
                  ],
                  [
                    -107.82018931209,
                    14.336553105945
                  ],
                  [
                    -107.79768961777,
                    14.320619576919
                  ],
                  [
                    -107.77829857264,
                    14.301021083084
                  ],
                  [
                    -107.7626053638,
                    14.278353114759
                  ],
                  [
                    -107.75108682146,
                    14.253304426691
                  ],
                  [
                    -107.74409293069,
                    14.226636110591
                  ],
                  [
                    -107.74183619733,
                    14.199158469749
                  ],
                  [
                    -107.74438519108,
                    14.171706398378
                  ],
                  [
                    -107.75166246205,
                    14.145114013775
                  ],
                  [
                    -107.76344689406,
                    14.12018931209
                  ],
                  [
                    -107.77938042308,
                    14.097689617771
                  ],
                  [
                    -107.79897891692,
                    14.078298572645
                  ],
                  [
                    -107.82164688524,
                    14.062605363804
                  ],
                  [
                    -107.84669557331,
                    14.05108682146
                  ],
                  [
                    -107.87336388941,
                    14.044092930691
                  ],
                  [
                    -107.90084153025,
                    14.041836197331
                  ],
                  [
                    -107.92829360162,
                    14.04438519108
                  ],
                  [
                    -109.05478997806,
                    13.852100219431
                  ],
                  [
                    -110.17555929492,
                    13.622203525418
                  ],
                  [
                    -111.3515348571,
                    13.528217142986
                  ],
                  [
                    -112.82307990937,
                    13.683154452995
                  ],
                  [
                    -114.75263817552,
                    14.226420223828
                  ],
                  [
                    -116.92711923476,
                    14.645651106155
                  ],
                  [
                    -118.76345651071,
                    14.473338864959
                  ],
                  [
                    -119.34906392319,
                    14.833137781444
                  ],
                  [
                    -119.86329621706,
                    15.289160203931
                  ],
                  [
                    -120.29052870426,
                    15.827550121869
                  ],
                  [
                    -120.61778014188,
                    16.431948830042
                  ],
                  [
                    -120.83510716057,
                    17.083991979542
                  ],
                  [
                    -120.93590638884,
                    17.763867569222
                  ],
                  [
                    -120.91711509315,
                    18.450917923321
                  ],
                  [
                    -120.77930423751,
                    19.124267364496
                  ],
                  [
                    -120.52666113504,
                    19.763456510708
                  ],
                  [
                    -120.16686221856,
                    20.349063923193
                  ],
                  [
                    -119.71083979607,
                    20.863296217057
                  ],
                  [
                    -119.17244987813,
                    21.290528704262
                  ],
                  [
                    -118.56805116996,
                    21.617780141877
                  ],
                  [
                    -117.91600802046,
                    21.835107160566
                  ],
                  [
                    -117.23613243078,
                    21.935906388838
                  ],
                  [
                    -116.54908207668,
                    21.917115093151
                  ],
                  [
                    -115.8757326355,
                    21.779304237514
                  ],
                  [
                    -115.23654348929,
                    21.526661135041
                  ],
                  [
                    -114.27268076524,
                    19.954148893845
                  ],
                  [
                    -112.44716182448,
                    17.773579776172
                  ],
                  [
                    -111.17692009063,
                    16.316845547005
                  ],
                  [
                    -110.6484651429,
                    15.871782857014
                  ],
                  [
                    -109.82444070508,
                    15.377796474582
                  ],
                  [
                    -108.94521002194,
                    14.947899780569
                  ],
                  [
                    -107.87170639838,
                    14.35561480892
                  ]
                ]
              ]
            },
            "properties": {
              "dtype": 6,
              "id": "EP-2-2018"
            }
          },
          {
            "type": "Feature",
            "geometry": {
              "type": "Point",
              "coordinates": [
                -77.9,
                24.2
              ]
            },
            "properties": {
              "n": "DummyCurrentPoint",
              "id": "EP-2-2018",
              "tn": "TropicalStorm",
              "t": 10,
              "c": null,
              "w": 46.0311779,
              "g": 57.5389724012,
              "lat": 24.2,
              "lon": -77.9,
              "dir": 270,
              "s": 8,
              "p": 29.53,
              "dt": "2018-06-06 18:00:00Z",
              "dis": 5000.3579828997,
              "dtype": 3,
              "iid": "CurrentPosition-TropicalStorm-"
            }
          }
        ]
      }; */
    }
}
